module.exports = __webpack_public_path__ + "static/media/1 4 tattoo leg skeleton dragon large blue.1280x1707.9b73eac3.webp";